


























import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import {
    MeasurementTypeConfigurationRow
} from "@/components/Admin/Settings/Typeform/Helpers/MeasurementTypeConfigurationRow";
import MeasurementTypeConfigurationView
    from "@/components/Admin/Settings/Typeform/Components/MeasurementTypeConfigurationView.vue";
import {CountRunner} from "@/helpers/CountRunner";
import {MeasurementTypeConfiguration} from "@/core/services/MedicaPro/models";
import {Api, Typeform_Form} from '@/core/services/MedicaPro/Api';
import {Constants} from "@/Constants";
import ApiService from "@/services/ApiService";

@Component({
    components: {
        MeasurementTypeConfigurationView

    }
})
export default class TypeformSettingsPage extends BaseComponent {

    // Bindings to parent

    // Bindings to view
    public isReady = false;
    public items: MeasurementTypeConfigurationRow[] = [];
    public typeformForms: Typeform_Form[] = [];
    public webhook = '';

    public mounted() {
        this.renderView();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        this.webhook = (ApiService.apiAxios?.defaults['baseURL'] ?? '') + '/integrations/typeform/forms/submissions/webhook';
        this.isReady = true;

        let identifiers: string[];
        let configurations: MeasurementTypeConfiguration[];

        const countRunner = new CountRunner(3);
        countRunner.setRunner(() => {
            const identifiersMap = new Map<string, MeasurementTypeConfigurationRow>();
            identifiers.forEach(identifier => {
                identifiersMap.set(identifier, new MeasurementTypeConfigurationRow(identifier));
            });
            configurations.forEach(configuration => {
                if (identifiersMap.has(configuration.measurement_identifier!)) {
                    identifiersMap.get(configuration.measurement_identifier!)!.configuration = configuration;
                }
            });
            this.items = Array.from(identifiersMap.values());
        });
        Api.measurementTypeConfigurations().get()
            .find(measurementTypeConfigurations => {
                configurations = measurementTypeConfigurations;
                countRunner.increment();
            });
        Api.measurementTypes().identifiersGetGet()
            .category('all')
            .find((values: string[]) => {
                identifiers = values;
                countRunner.increment();
            });
        Api.integrationsTypeform().getFormsGet()
            .find(forms => {
                this.typeformForms = forms;
                countRunner.increment();
            });
        countRunner.start();
    }

    public onWebhookClicked() {
        navigator.clipboard.writeText(this.webhook);
        this.$toast('Link tilføjet til clipboard');
    }

}
